import React, { useContext, useState } from "react";
import parse from 'html-react-parser';
import "../App.css";
import { getText } from "../utils/languageUtils";
import LanguageContext from "./hooks/LanguageContext";

const ReadMoreResourcesShortLongAbout = ({ short, long, filePath, language }) => {
	const [isReadMore, setIsReadMore] = useState(false);
	const { translations: translationData } = useContext(LanguageContext);
	const translations = translationData?.about || {};
	const toggleReadMore = () => {
		setIsReadMore(!isReadMore);
	};

	const readMoreText = getText(translations.read_more, language);
	const readLessText = getText(translations.read_less, language);
	
	return (
		<div className="text textP" style={{ margin: 0 }}>
			<img src={filePath} alt="" style={{ width: "90px", marginRight: "15px", float: "left" }} />
			{isReadMore === false ? parse(String(short).replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")) : parse(String(long).replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""))}
			<span onClick={toggleReadMore} className="read-or-hide" style={{ fontWeight: 400, color: "#792110" }}>
				{isReadMore === false ? ` ${readMoreText}` : ` ${readLessText}`}
			</span>
		</div>
	)
}


export default ReadMoreResourcesShortLongAbout;
